import Vue from 'vue'
import VueRouter from 'vue-router'
import DuanYouView from '../components/DuanYouView.vue'
import ShouYouView from '../components/ShouYouView.vue'
import ComputeView from '../components/ComputeView.vue'

Vue.use(VueRouter)

// 打包的时候记得修改这边 
// const baseUrl = "/exp/"
const baseUrl = "/"

const routes = [
  {
    path: '/compute/dy',
    redirect: '/compute/lxg'
  },
  {
    path: '/compute',
    name: 'compute',
    component: ComputeView,
    redirect: '/compute/lxg',
    children:[
      {
        // 这个方式可以把target作为参数传出去 使用this.$router.param.target获取
        path: '/compute/:target', 
        // path: '/compute/dy',
        name: 'duanYou',
        component: DuanYouView
      },
      // {
      //   path: '/compute/sy',
      //   name: 'shouyou',
      //   component: ShouYouView
      // },
    ]
  },
  {
    path: '/',
    redirect: '/compute'
  },

]

const router = new VueRouter({
  base: baseUrl, 
  mode: 'history', // 去掉url中的#
  routes
})


// 路由导航守卫
router.beforeEach((to, from, next) =>{
  if(to.path === '/login') return '/';
  return next();
})

export default router
